import request from "../../../../utils/api";

const url = "api/v1/companies"

export const getSale = (company_id, params) => request(`${url}/${company_id}/sales`, { params });
export const updateSale = (company_id, sale_id, body) => request(`${url}/${company_id}/sales/${sale_id}`, { method: "put", body });
export const deleteSale = (company_id, sale_id) => request(`${url}/${company_id}/sales/${sale_id}`, { method: "delete" });
export const addSale = (company_id, body) => request(`${url}/${company_id}/sales/copy`, { method: "post", body });


// WEBPACK FOOTER //
// ./src/modules/company/pages/sales-forecast/service.js